// extracted by mini-css-extract-plugin
module.exports = {"ProductUpsales":"styles_ProductUpsales__Yv1AA","subtitle":"styles_subtitle__px_pf","upsales":"styles_upsales__PSA5M"};